<script>
import Layout from '@layouts/main'
import 'vue-loading-overlay/dist/vue-loading.css'
import StatChart from '@components/widget-stat-chart'
import dashboardService from '@/src/services/serviceDasboard'
import EstoqueModel from '@/src/model/estoque.model'
import alertMixin from '@/src/mixins/alertMixin'
import requisicoesModel from '@/src/model/requisicoes.model'
import moment from 'moment'
import formataDescricaoInsumo from '@/src/utils/formataDescricaoInsumo'
import RequisicoesForm from '@/src/components/forms/controleObra/requisicoesForm.vue'
import serviceObraRequisicoes from '../../../../services/serviceObraRequisicoes'
import tableItems from '../../../../components/tableItens.vue'
import { mapState } from 'vuex'
import serviceEstoqueObra from '@/src/services/serviceEstoqueObra'
import loadingComponent from '@/src/components/loading/loading-component.vue'

/**
 * Dashboard-1 Component
 */
export default {
  components: {
    Layout,
    StatChart,
    RequisicoesForm,
    tableItems,
    loadingComponent,
  },
  mixins: [alertMixin],
  data() {
    return {
      isLoading: false,
      formOpen: false,
      requisicao: {},
      listaItensEstoqueBaixo: [],
      lowStockFields: EstoqueModel.lowStockFields,
      grupoFields: requisicoesModel.grupoFieldsDashboard,
      statChart: [
        {
          mainTitle: 'Total de Obras',
          value: 0,
          chartColor: '#5369f8',
        },
        {
          mainTitle: 'Total de Requisições',
          value: 0,
          chartColor: '#f77e53',
        },
        {
          mainTitle: 'Total Estoque R$',
          value: 0,
          chartColor: '#43d39e',
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: { categories: [] },
      },
      // series: [{ data: [], name: 'receitas' }],
      page: 1,
      pendingRequests: [],
      pageRequests: 1,
      perPage: 10,
      rows: 0,
      rowsRequests: 0,
      openModalDelete: false,
      tipo_conta: this.$attrs.user.user.tipo_conta,
      messageFeedbackLoading: '',
      messageError: '',
      currentDate: new Date().toLocaleDateString('pt-BR', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
      }),
      currentTime: new Date().toLocaleTimeString('pt-BR', {
        hour: '2-digit', minute: '2-digit'
      })
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
  },
  watch: {},

  mounted() {
    //this.handleGet(0)
    setInterval(() => {
      this.currentTime = new Date().toLocaleTimeString('pt-BR', {
        hour: '2-digit', minute: '2-digit'
      });
    }, 1000);
  },

  methods: {
    getLowStock(page) {
      this.messageFeedbackLoading = 'Carregando itens com estoque baixo...'
      this.isLoading = true
      const filial = this.$store.state.filial || null
      this.listaItensEstoqueBaixo = []

      if (filial) {
        serviceEstoqueObra
          .getLowStock(page, filial)
          .then((res) => {
            const { data } = res.data

            data.results.forEach((item) => {
              if (!item.insumo.descricao_pai && !item.insumo.descricao) {
                item.descricao = `${item.insumo.descricao_pai}`
              }
              if (!item.insumo.descricaoPai && !item.insumo.descricao) {
                item.descricao = `${item.insumo.descricaoPai}`
              }
              if (item.insumo.descricaoPai && item.insumo.descricao) {
                item.descricao = `${item.insumo.descricaoPai} - ${item.insumo.descricao
                  }`
              }
              if (item.insumo.descricao_pai && item.insumo.descricao) {
                item.descricao = `${item.insumo.descricao_pai} - ${item.insumo.descricao
                  }`
              }
              if (!item.insumo.descricao_pai && !item.insumo.descricaoPai) {
                item.descricao = `${item.insumo.descricao}`
              }
            })
            this.listaItensEstoqueBaixo = this.listaItensEstoqueBaixo.sort(
              (a, b) => {
                if (a.descricao < b.descricao) {
                  return -1
                }
                if (a.descricao > b.descricao) {
                  return 1
                }
                return 0
              }
            )

            this.listaItensEstoqueBaixo = data.results
            this.rows = data.count
          })
          .finally(() => {
            this.isLoading = false
            this.messageFeedbackLoading = ''
          })
      } else {
        serviceEstoqueObra
          .getLowStock(page)
          .then((res) => {
            const { data } = res.data

            data.results.forEach((item) => {
              if (!item.insumo.descricao_pai && !item.insumo.descricao) {
                item.descricao = `${item.insumo.descricao_pai}`
              }
              if (!item.insumo.descricaoPai && !item.insumo.descricao) {
                item.descricao = `${item.insumo.descricaoPai}`
              }
              if (item.insumo.descricaoPai && item.insumo.descricao) {
                item.descricao = `${item.insumo.descricaoPai} - ${item.insumo.descricao
                  }`
              }
              if (item.insumo.descricao_pai && item.insumo.descricao) {
                item.descricao = `${item.insumo.descricao_pai} - ${item.insumo.descricao
                  }`
              }
              if (!item.insumo.descricao_pai && !item.insumo.descricaoPai) {
                item.descricao = `${item.insumo.descricao}`
              }
            })
            this.listaItensEstoqueBaixo = this.listaItensEstoqueBaixo.sort(
              (a, b) => {
                if (a.descricao < b.descricao) {
                  return -1
                }
                if (a.descricao > b.descricao) {
                  return 1
                }
                return 0
              }
            )

            this.listaItensEstoqueBaixo = data.results
            this.rows = data.count
          })
          .finally(() => {
            this.isLoading = false
            this.messageFeedbackLoading = ''
          })
      }
    },
    approval(item) {
      const isApproved = item.status === 'aprovado'
      const isPending = item.status === 'pendente'

      if (
        (isApproved && this.tipo_conta === 'almoxarifado') ||
        (this.tipo_conta === 'engenheiro' && isPending) ||
        this.tipo_conta === 'administrador'
      ) {
        this.messageFeedbackLoading = 'Efetivando a solicitação...'
        this.isLoading = true
        item.status = isApproved ? 'concluido' : 'aprovado'
        const payload = isPending
          ? { ...item, approved_user: this.currentUser.user._id }
          : { ...item, concluded_user: this.currentUser.user._id }

        serviceObraRequisicoes
          .approval(payload.id_requisition, payload)
          .then(() => {
            if (payload.status === 'concluido') {
              this.$bvModal.hide('modal-approval')
              this.getOnlyPendingRequests(
                this.pageRequests,
                'Requisição concluída com sucesso, carregando requisições pendentes...'
              )
            } else {
              this.successMessage('Item Aprovado com sucesso')
            }

            this.isLoading = false
          })
          .catch((error) => {
            if (payload.status === 'concluido') {
              this.requisicao.status = 'aprovado'
            }
            if (payload.status === 'concluido') {
              this.requisicao.status = 'pendente'
            }
            this.errorMessage(
              error.response.data.error.message || 'Erro ao aprovar item'
            )

            this.isLoading = false
          })
      } else
        switch (this.tipo_conta) {
          case 'engenheiro':
            this.errorMessage(
              'somente perfis administradores e almoxarifado podem conluir o pedido'
            )
            break
          case 'almoxarifado':
            this.errorMessage(
              'somente perfis administradores e equipe de apoio podem aprovar o pedido'
            )
            break
          default:
            this.errorMessage('não autorizado')
            break
        }
    },
    getOnlyPendingRequests(page, message) {
      this.isLoading = true
      this.messageFeedbackLoading =
        message || 'Carregando requisições pendentes...'
      serviceObraRequisicoes
        .pendingRequests(page)
        .then((res) => {
          const { data } = res.data
          this.rowsRequests = data.count
          this.pendingRequests = data.results
        })
        .finally(() => {
          this.isLoading = false
          this.messageFeedbackLoading = ''
          this.messageError = ''
        })
    },
    cancelaDelete() {
      this.idDelete = ''
      this.openModalDelete = false
    },
    onDelete(id) {
      this.isLoading = true
      serviceObraRequisicoes
        .remove(id)
        .then(() => {
          this.successMessage('Requisição removido com sucesso')
          this.openModalDelete = false
          this.idDelete = ''
        })
        .catch((err) => {
          console.log(err)
          this.errorMessage('erro ao deletar')
        })
        .finally(() => {
          this.isLoading = false
          this.getOnlyPendingRequests(this.pageRequests)
        })
    },
    async salvar(requisicao) {
      if (requisicao.tipo === 'emprestimo') {
        if (requisicao.obra._id === requisicao.obra.obraEmprestimo._id) {
          this.errorMessage(
            'Só é possível realizar empréstimos para obras diferentes de uma mesma filial.'
          )
        } else {
          this.isLoading = true

          try {
            if (!requisicao._id) {
              await serviceObraRequisicoes.createLoan({
                ...requisicao,
                user: this.$attrs.user.user._id,
              })
            }
          } catch (error) {
            console.log(error)
          } finally {
            alert('Ainda não é possível realizar empréstimo.')
            this.isLoading = false
            this.error = ''
          }
        }
      } else {
        this.isLoading = true

        try {
          if (requisicao._id) {
            await serviceObraRequisicoes.update(requisicao._id, requisicao)
          }

          if (!requisicao._id) {
            await serviceObraRequisicoes.create({
              ...requisicao,
              user: this.$attrs.user.user._id,
            })
          }

          this.messageFeedbackLoading = 'Requisição salva com sucesso.'
          this.abrirForm()
          this.listaRequisicoes()
        } catch (error) {
          this.messageFeedbackLoading = ''
          this.error = error.response.data.error.message
        } finally {
          this.isLoading = false
          this.error = ''
        }
      }
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.requisicao = {}
    },
    edit(item) {
      this.abrirForm()
      this.requisicao = item
    },
    itensTable(item) {
      item.itens.forEach((element) => {
        element.descricao = formataDescricaoInsumo(element)
      })
      this.requisicao = item
      this.$bvModal.show('modal-approval')
    },
    modalDelete(item) {
      this.idDelete = item
      this.openModalDelete = true
    },
    formatDate(date) {
      if (date) {
        return moment.utc(date).format('DD/MM/YYYY')
      } else {
        return ' '
      }
    },
    handleMessages() {
      this.messageFeedbackLoading = ''
      this.messageError = ''

      this.messageFeedbackLoading = [
        `Olá ${this.$attrs.user.user.nome
        }, aguarde um momento, estamos carregando os dados do dashboard.`,
        'Calculando estatísticas...',
        'Listando itens com estoque baixo...',
        'Verificando requisições pendentes...',
      ]
    },
    updateByFiliais() {
      //this.handleGet(0)
    },
    handleGet(currentPage) {
      this.listaItensEstoqueBaixo = []
      this.pendingRequests = []
      this.rows = 0
      this.rowsRequests = 0
      this.handleMessages()

      this.isLoading = true
      const filter = null

      dashboardService
        .list(currentPage, filter, this.$store.state.filial || null)
        .then((res) => {
          const { data } = res.data

          this.rowsRequests = data.pendingRequests.count
          this.pendingRequests = data.pendingRequests.results
          this.page = 1
          this.pageRequests = 1

          this.statChart[0].value = data.countObras
          this.statChart[1].value = data.countRequisicoes
          this.statChart[2].value = data.totalGeralMonerarioEstoque
          this.listaItensEstoqueBaixo = data.listaItensEstoqueBaixo.results
          this.listaItensEstoqueBaixo.forEach((item) => {
            if (!item.insumo.descricao_pai && !item.insumo.descricao) {
              item.descricao = `${item.insumo.descricao_pai}`
            }
            if (!item.insumo.descricaoPai && !item.insumo.descricao) {
              item.descricao = `${item.insumo.descricaoPai}`
            }
            if (item.insumo.descricaoPai && item.insumo.descricao) {
              item.descricao = `${item.insumo.descricaoPai} - ${item.insumo.descricao
                }`
            }
            if (item.insumo.descricao_pai && item.insumo.descricao) {
              item.descricao = `${item.insumo.descricao_pai} - ${item.insumo.descricao
                }`
            }
            if (!item.insumo.descricao_pai && !item.insumo.descricaoPai) {
              item.descricao = `${item.insumo.descricao}`
            }
          })
          this.listaItensEstoqueBaixo = this.listaItensEstoqueBaixo.sort(
            (a, b) => {
              if (a.descricao < b.descricao) {
                return -1
              }
              if (a.descricao > b.descricao) {
                return 1
              }
              return 0
            }
          )

          this.rows = data.listaItensEstoqueBaixo.count

          // this.chartOptions = {
          //   xaxis: {
          //     categories: Object.keys(data.totalRequisicoesMes),
          //   },
          // }
          // this.series = [
          //   {
          //     data: Object.values(data.totalRequisicoesMes),
          //   },
          // ]

          this.isLoading = false
        })
        .catch((err) => {
          console.log(err)
          this.isLoading = false
          this.errorMessage(`Erro ao carregar dados do dashboard`)
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row page-title align-items-center"> </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body d-flex justify-content-between align-items-center">
            <div class="text-center flex-fill">
              <h3 class="greeting-text">Olá, <span id="personName">{{ this.$attrs.user.user.nome }}</span></h3>
              <h1>Bem Vindo</h1>
            </div>
            <div class="text-right">
              <p id="localInfo">São Paulo, {{ currentDate }}</p>
              <p id="timeInfo"><strong>{{ currentTime }} hr</strong></p>
            </div>
          </div>
          <hr>
          <div class="col-10 mt-4 d-flex justify-content-between align-items-center">
            <div class="logo-container text-center">
              <img src="@assets/images/logo.png" alt="CFObras Logo" class="logo">
            </div>
            <div class="buttons-container text-center">
              <h3>Atalhos</h3>
              <div class="row">
                <div class="col-3 mb-2">
                  <b-button href="/materiais/requisicoes/" class="btn btn-primary btn-block">Nova Requisição Materiais</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/equipamentos/requisicoes-equipamentos/" class="btn btn-primary btn-block">Nova Requisição Equipamentos</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/materiais/cadastro-insumo/" class="btn btn-primary btn-block">Recebimento de materiais</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/materiais/estoque/" class="btn btn-primary btn-block">Cadastro de Estoque</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/materiais/kit-insumo/" class="btn btn-primary btn-block">Criação de Kits</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/materiais/low-stock/" class="btn btn-primary btn-block">Estoque Mínimo</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/relatorios/indexes-report/" class="btn btn-primary btn-block">Índices</b-button>
                </div>
                <div class="col-3 mb-2">
                  <b-button href="/estatisticas/obras-filiais/" class="btn btn-primary btn-block">Estatísticas</b-button>
                </div>
              </div>
            </div>
            
          </div>
          <div class="logo-container text-right">
              <img src="@assets/images/cf_obrinha.png" alt="CFObras Logo" class="logo">
            </div>
        </div>
      </div>
    </div>

    <loading-component :is-loading="isLoading" :text="messageFeedbackLoading" :message-error="messageError"
      array-message="true" />

    <b-modal v-model="formOpen" title="Editar Requisição" size="lg" hide-footer>
      <RequisicoesForm :requisicao="requisicao" @onRequisicao="salvar" />
    </b-modal>

    <b-modal v-model="openModalDelete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="cancelaDelete">Não</b-button>
        <b-button variant="danger" @click="onDelete(idDelete)">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="modal-approval" size="lg" title="Conferência da Requisição" ok-only>
      <tableItems :requisicao="requisicao" @return-item="approval" />
    </b-modal>
  </Layout>
</template>
<style src="../style.scss" lang="scss"></style>

<style scoped>
.card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.flex-fill {
  flex: 1;
}

.greeting-text,
h1 {
  margin: 0;
}

.text-right p {
  margin: 0;
}

.logo-container {
  flex: 1;
}

.logo {
  max-width: 250px;
  margin-bottom: 10px;
}
</style>
